<template>
  <div class="radio">
    <a href="javascript:;" :class="{ active: gender + '' === 'true' }" @click="changeChecked(true)">男</a>
    <a href="javascript:;" :class="{ active: gender + '' === 'false' }" @click="changeChecked(false)">女</a>
  </div>
</template>

<script>
export default {
  name: 'VerifyRadio',
  props: {
    gender: {
      type: Boolean
    }
  },
  setup (props, { emit }) {
    const changeChecked = boolean => {
      emit('change', boolean)
    }
    return { changeChecked }
  }
}
</script>

<style lang="less" scoped>
.radio {
  height: 46px;
  display: flex;
  align-items: center;
  a {
    height: 30px;
    line-height: 30px;
    box-shadow: 0 0 1px #e4e4e4;
    padding: 0 20px;
    margin-right: 20px;
    color: #666;
    border-radius: 2px;
    position: relative;
    transition: all 0.3s;
    background: #fff;
    &:hover {
      box-shadow: 0 0 1px @themeColor;
    }
    &.active {
      background: @themeColor;
      border-color: @themeColor;
      color: #fff;
    }
  }
}
</style>
